export default __webpack_public_path__ + "static/media/metacritic-icon.6caa5bd6.png";